import React from 'react';
import {connect} from 'react-redux';
import {BannerItem} from './BannerItem';
import {TESTS, getValue} from '../../../utils/abacus';

function mapStateToProps(state) {
    return {
        banner: state.config.context.bodyConfig.banner,
        abacus: state.abacus
    };
}

export const BannerComponent = ({banner, vertical, container, abacus}) => {
    const classNames = [
        'banner',
        getValue(abacus, TESTS.SLP_2134) === 1 ? ' slp2134' : '',
        vertical ? ' banner--vertical' : '',
        container ? ' container' : ''
    ].join('');

    return (
        <ul className={classNames}>
            {banner.map((type) => (
                <li key={type}>
                    <BannerItem type={type} />
                </li>
            ))}
        </ul>
    );
};

export const Banner = connect(mapStateToProps)(BannerComponent);
